(function () {
  // Clicking a thumbnail shows that image in the main product image.
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-pdp-thumbnail]');
    if (!thumb) return;
    const media = thumb.closest('.product-pdp__media');
    const main = media && media.querySelector('[data-pdp-main-image]');
    if (!main) return;

    main.srcset = thumb.dataset.srcset;
    main.src = thumb.dataset.src;
    main.width = thumb.dataset.width;
    main.height = thumb.dataset.height;
    main.alt = thumb.dataset.alt;

    media.querySelectorAll('[data-pdp-thumbnail]').forEach((other) => {
      other.setAttribute('aria-current', other === thumb ? 'true' : 'false');
    });
  });
})();
